import * as React from "react";
import {IoIosSwap, IoMdShare} from "react-icons/io";
import {fetchTranslationsFromKeys} from "@/api/actions/translations";

const ProductPageTours = {
    page: "product",
    tours: [
        // {
        //     tour: "productTour",
        //     steps: [
        //         {
        //             icon: <IoIosSwap />,
        //             title: "ArticlePageTour.variantFilter.title",
        //             content: "ArticlePageTour.variantFilter.content",
        //             selector: "#variant-filter-switch",
        //             side: "top",
        //             showControls: true,
        //             pointerPadding: 0,
        //             pointerRadius: 11,
        //         },
        //         {
        //             icon: <IoMdShare />,
        //             title: "ArticlePageTour.shareConfig.title",
        //             content: "ArticlePageTour.shareConfig.content",
        //             selector: "#share-config-button",
        //             side: "top",
        //             showControls: true,
        //             pointerPadding: 0,
        //             pointerRadius: 11,
        //         },
        //         {
        //             icon: <IconDocument />,
        //             title: "ArticlePageTour.watchlist.title",
        //             content: "ArticlePageTour.watchlist.content",
        //             selector: "#product-to-watchlist-button",
        //             side: "top",
        //             showControls: true,
        //             pointerPadding: 0,
        //             pointerRadius: 11,
        //         },
        //         {
        //             icon: <p>CSV</p>,
        //             title: "ArticlePageTour.csv.title",
        //             content: "ArticlePageTour.csv.content",
        //             selector: "#csv-button",
        //             side: "top",
        //             showControls: true,
        //             pointerPadding: 0,
        //             pointerRadius: 11,
        //         },
        //         {
        //             title: "ArticlePageTour.tenderText.title",
        //             content: "ArticlePageTour.tenderText.content",
        //             selector: "#tender-text-button",
        //             side: "top",
        //             showControls: true,
        //             pointerPadding: 0,
        //             pointerRadius: 11,
        //         },
        //         {
        //             title: "ArticlePageTour.datasheet.title",
        //             content: "ArticlePageTour.datasheet.content",
        //             selector: "#datasheet-button",
        //             side: "top",
        //             showControls: true,
        //             pointerPadding: 0,
        //             pointerRadius: 11,
        //         },
        //         {
        //             icon: <FaPaintBrush />,
        //             title: "ArticlePageTour.paintBrush.title",
        //             content: "ArticlePageTour.paintBrush.content",
        //             selector: "#paint-button",
        //             side: "bottom",
        //             showControls: true,
        //             pointerPadding: 0,
        //             pointerRadius: 11,
        //         }
        //     ]
        // },
        {
            tour: "variantSwitchTour",
            steps: [
                {
                    icon: <IoIosSwap />,
                    title: "ArticlePageTour.variantFilter.title",
                    content: "ArticlePageTour.variantFilter.content",
                    selector: "#variant-filter-switch",
                    side: "top",
                    showControls: true,
                    pointerPadding: 0,
                    pointerRadius: 11,
                }
            ]
        }
    ]
}

// const ProjectsPageTour = {
//     tour: "projectsTour",
//     steps: [
//         {
//             icon: <PlusSvg />,
//             title: "ProjectsPageTour.addButton.title",
//             content: "ProjectsPageTour.addButton.content",
//             selector: "#add-project-button",
//             side: "top",
//             showControls: true,
//             pointerPadding: 0,
//             pointerRadius: 11,
//         },
//     ]
// }

export const TOURS = [
    ProductPageTours
]

const steps = [
    ...ProductPageTours.tours
]

export async function getSteps(language: string) {
    const keys: string[] = [];

    steps.forEach(tourObject => {
        if (tourObject.steps) {
            tourObject.steps.forEach(step => {
                if (typeof step.title === "string") {
                    keys.push(step.title);
                }
                if (typeof step.content === "string") {
                    keys.push(step.content);
                }
            });
        }
    });

    const t = await fetchTranslationsFromKeys(Array.from(keys), language);

    return steps.map(tour => ({
        ...tour,
        steps: tour.steps.map((step) => ({
            ...step,
            title: t[step.title],
            content: t[step.content],
        }))
    }))
}